<template>
    <div id="shduleBatch">
        <a-modal
                title="Add Project"
                :visible="visible"
                @cancel="cancel"
                width="45%"
        >
            <template slot="footer">
                <a-button size="small" type="primary" @click="savePro">Save</a-button>
            </template>
            <vxe-table
                border
                resizable
                highlight-hover-row
                size="mini"
                :data="tableData"
                 ref="scheduleAddProRefs">
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="displayName" title="Project" minWidth="150"></vxe-table-column>
            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import { mapState } from "vuex";
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    export default{
        data(){
            return{
                visible: false,
                form:this.$form.createForm(this),
                tableData: [],
                targetRow: {}
            }
        },
        computed: {
            ...mapState(["lang"]),
        },
        methods:{
            show(row){
                console.log(row);
                this.targetRow = row
                this.visible = true
                ajax.get(api.USERALLPROJECT).then(res=>{
                    this.tableData = res.data.projectCodes
                })
            },
            cancel(){
                this.visible = false
            },
            savePro(){
                let checkboxLen = this.$refs.scheduleAddProRefs.getCheckboxRecords()
                if(checkboxLen.length > 0){
                    let arr = []
                    for(let i in checkboxLen){
                        arr.push(checkboxLen[i].uid)
                    }
                    let params = {
                        geRtMasterUid:this.targetRow.uid,
                        projectUids:arr
                    }
                    ajax.post(api.SCHEDULSAVE,params).then(res=>{
                        if(res.code == 200){
                            this.$emit('schduleProEmit','init')
                            this.visible = false
                        }else{
                            this.$customMessage.warning(res.msg)
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }

            },
        }
    }
</script>